'use strict';
app.factory("errorHandlerService", ['$rootScope', function ($rootScope)
{
    /*
        We handle the error status and msg returned,
        Refers:- http://msdn.microsoft.com/en-us/library/system.net.httpstatuscode(v=vs.110).aspx
        ConnectionFailed = 0,
        BadRequest = 400,
        Unauthorize = 401,
        Forbidden = 403,
        MethodNotAllowed = 405,
        InternalServerError = 500
    */
    const httpStatusCode_CustomException = 419;

    const EXCEPTION_COULD_NOT_FIND_SERVER = "We are unable to contact server. Please verify you have a working internet connection. If it persists, please contact our support.";
    const EXCEPTION_UNEXPECTED = "You have encountered an unexpected error. Please try again. If it persists, please contact our support.";
    const EXCEPTION_EXPIRED_SESSION = "Your session has expired. Please login again. If it persists, please contact our support.";
    const EXCEPTION_REFERENCE_IN_USE = "You are not allowed to delete a record that is currently in use. Please verify and try again. If it persists, please contact our support.";
    const EXCEPTION_REFERENCE_INVALID = "Your request contains invalid record. Please verify and try again. If it persists, please contact our support.";
    const EXCEPTION_BAD_REQUEST = "You have encountered a bad request. Please try again. If it persists, please contact our support.";
    const EXCEPTION_NO_PERMISSION = "You are not authorized to perform this action. Please try again. If it persists, please contact our support.";
    const EXCEPTION_REQUEST_TOO_LONG = "Your request is too large. Please try again. If it persists, please contact our support.";
    const EXCEPTION_NOT_FOUND = "You are requesting a record that is no longer available. Please refresh and try again. If it persists, please contact our support.";

    const _unAuth = () =>
    {
        //broadcast to reauthorize or validate login session
        $rootScope.unauthorized = true;
        $rootScope.$emit("CallReloginMethod", {});
    }

    const _getExceptionMessage = (responseJSON) =>
    {
        let exceptionMessage = "";

        if (typeof responseJSON?.["odata.error"]?.message?.value == "string")
        {
            if (responseJSON["odata.error"].message.value.trim() != "An error has occurred.")
                exceptionMessage += (responseJSON["odata.error"].message.value + (responseJSON["odata.error"].message.value.endsWith(".") ? " " : ". "));

            if (typeof responseJSON?.["odata.error"]?.innererror != "undefined")
            {
                let innerExceptionMessage = _getExceptionMessage(responseJSON["odata.error"].innererror);

                if (typeof innerExceptionMessage == "string" && innerExceptionMessage.trim() != "" && innerExceptionMessage.trim() != "An error has occurred.")
                    exceptionMessage += innerExceptionMessage;
            }

            if (typeof responseJSON?.["odata.error"]?.internalexception != "undefined")
            {
                let innerExceptionMessage = _getExceptionMessage(responseJSON["odata.error"].internalexception);

                if (typeof innerExceptionMessage == "string" && innerExceptionMessage.trim() != "" && innerExceptionMessage.trim() != "An error has occurred.")
                    exceptionMessage += innerExceptionMessage;
            }
        }
        else if (typeof responseJSON?.message == "string")
        {
            if (responseJSON.message.trim() != "An error has occurred.")
                exceptionMessage += (responseJSON.message + (responseJSON.message.endsWith(".") ? " " : ". "));

            if (typeof responseJSON?.internalexception != "undefined")
            {
                let innerExceptionMessage = _getExceptionMessage(responseJSON.internalexception);

                if (typeof innerExceptionMessage == "string" && innerExceptionMessage.trim() != "" && innerExceptionMessage.trim() != "An error has occurred.")
                    exceptionMessage += innerExceptionMessage;
            }
        }

        return exceptionMessage;
    }

    const _getStatus = (error) =>
    {
        try
        {
            if (_.isNil(error) || _.isNil(error.xhr))
            {
                return { code: EXCEPTION_UNEXPECTED, desc: EXCEPTION_UNEXPECTED };
            }

            const { status, errorThrown, responseText, responseJSON } = error.xhr;

            if (status === 0)
            {
                return { code: EXCEPTION_COULD_NOT_FIND_SERVER, desc: EXCEPTION_COULD_NOT_FIND_SERVER };
            }

            if ([400, httpStatusCode_CustomException].includes(status))
            {
                if (responseText)
                {
                    try
                    {
                        const { message } = (responseJSON?.["odata.error"]) ?? {};

                        if (message)
                        {
                            const { MsgKey, MsgItem } = JSON.parse(message.value);

                            if (MsgKey === 214 || MsgKey === 228)
                            {
                                return { code: EXCEPTION_REFERENCE_IN_USE, desc: EXCEPTION_REFERENCE_IN_USE };
                            }
                        }
                    }
                    catch { }
                }

                return { code: EXCEPTION_BAD_REQUEST, desc: EXCEPTION_BAD_REQUEST };
            }

            if (status === 401)
            {
                return { code: EXCEPTION_EXPIRED_SESSION, desc: EXCEPTION_EXPIRED_SESSION };
            }

            if (status === 403)
            {
                return { code: EXCEPTION_NO_PERMISSION, desc: EXCEPTION_NO_PERMISSION };
            }

            if (status === 404)
            {
                return { code: EXCEPTION_NOT_FOUND, desc: EXCEPTION_NOT_FOUND };
            }

            if (status === 414)
            {
                return { code: EXCEPTION_REQUEST_TOO_LONG, desc: EXCEPTION_REQUEST_TOO_LONG };
            }

            if (status === 500)
            {
                const errorThrownJSON = _getExceptionMessage(responseJSON);

                if ((errorThrown ?? "").toLowerCase().includes("this record is currently in use")
                    || (responseText ?? "").toLowerCase().includes("this record is currently in use")
                    || (errorThrownJSON ?? "").toLowerCase().includes("this record is currently in use")
                    || (errorThrown ?? "").toLowerCase().includes("conflicted with the reference constraint")
                    || (responseText ?? "").toLowerCase().includes("conflicted with the reference constraint")
                    || (errorThrownJSON ?? "").toLowerCase().includes("conflicted with the reference constraint"))
                {
                    return { code: EXCEPTION_REFERENCE_IN_USE, desc: EXCEPTION_REFERENCE_IN_USE };
                }

                if ((errorThrown ?? "").toLowerCase().includes("conflicted with the check constraint")
                    || (responseText ?? "").toLowerCase().includes("conflicted with the check constraint")
                    || (errorThrownJSON ?? "").toLowerCase().includes("conflicted with the check constraint"))
                {
                    return { code: EXCEPTION_REFERENCE_INVALID, desc: EXCEPTION_REFERENCE_INVALID };
                }

                if ((errorThrown ?? "").toLowerCase().includes("could not find matching token")
                    || (responseText ?? "").toLowerCase().includes("could not find matching token")
                    || (errorThrownJSON ?? "").toLowerCase().includes("could not find matching token"))
                {
                    return { code: EXCEPTION_EXPIRED_SESSION, desc: EXCEPTION_EXPIRED_SESSION };
                }

                if (errorThrownJSON)
                {
                    const errCode = ((responseJSON?.["odata.error"]?.innererror?.message) ?? "").trim() != "" ? responseJSON["odata.error"].innererror.message : EXCEPTION_UNEXPECTED;
                    const errDesc = errorThrownJSON;
                    return (errDesc.trim() != "" && errCode.replaceAll(".", "").replaceAll(" ", "") != errDesc.replaceAll(".", "").replaceAll(" ", ""))
                        ? { code: `${errCode} <a ng-click="$parent.msgHeader='${errDesc}'; msgHeader='${errDesc}'; $event.stopPropagation();" target="_blank" style="cursor:pointer">Show Details</a>` }
                        : { code: errCode, desc: errCode };
                }

                if (responseText)
                {
                    const errCode = responseText.substring(responseText.indexOf("innererror") + 32, responseText.indexOf("type") - 3).replace(/(\\r|\\n|\\)/g, "");
                    const errDesc = responseText.substring(responseText.lastIndexOf("message") + 10, responseText.lastIndexOf("type") - 3).replace(/(\\r|\\n|\\)/g, "").replace(/\"|\'/g, "&quot;");
                    return (errDesc.trim() != "" && errCode.replaceAll(".", "").replaceAll(" ", "") != errDesc.replaceAll(".", "").replaceAll(" ", ""))
                        ? { code: `${errCode} <a ng-click="$parent.msgHeader='${errDesc}'; msgHeader='${errDesc}'; $event.stopPropagation();" target="_blank" style="cursor:pointer">Show Details</a>` }
                        : { code: errCode, desc: errCode };
                }
            }

            return { code: EXCEPTION_UNEXPECTED, desc: EXCEPTION_UNEXPECTED };
        }
        catch { }

        return { code: EXCEPTION_UNEXPECTED, desc: EXCEPTION_UNEXPECTED };
    };

    const _getExceptionMessageAPI = (error) =>
    {
        let exceptionMessage = "";

        if (typeof error?.ExceptionMessage == "string" && error.ExceptionMessage.trim() != "" && error.ExceptionMessage.trim() != "An error has occurred.")
            exceptionMessage += (error.ExceptionMessage + (error.ExceptionMessage.endsWith(".") ? " " : ". "));

        if (typeof error?.InnerException != "undefined")
        {
            let innerExceptionMessage = _getExceptionMessageAPI(error.InnerException);

            if (typeof innerExceptionMessage == "string" && innerExceptionMessage.trim() != "" && innerExceptionMessage.trim() != "An error has occurred.")
                exceptionMessage += innerExceptionMessage;
        }

        return exceptionMessage;
    }

    const _getStatusAPI = (status, error) =>
    {
        try
        {
            if (_.isNil(error))
            {
                return { status: EXCEPTION_UNEXPECTED, desc: EXCEPTION_UNEXPECTED };
            }

            if (status == 0)
            {
                return EXCEPTION_COULD_NOT_FIND_SERVER;
            }

            if ([400, httpStatusCode_CustomException].includes(status))
            {
                return ((typeof (error?.Message) === "string") && (error?.Message) != "") ? error.Message : EXCEPTION_BAD_REQUEST;
            }

            if (status == 401)
            {
                return EXCEPTION_EXPIRED_SESSION;
            }

            if (status == 403)
            {
                return EXCEPTION_NO_PERMISSION;
            }

            if (status === 404)
            {
                return EXCEPTION_NOT_FOUND;
            }

            if (status == 414)
            {
                return EXCEPTION_REQUEST_TOO_LONG;
            }

            if (status == 500)
            {
                if (((error?.["odata.error"]?.innererror?.internalexception?.internalexception?.message) ?? "").includes("this record is currently in use")
                    || ((error?.["odata.error"]?.innererror?.internalexception?.internalexception?.message) ?? "").includes("conflicted with the reference constraint"))
                {
                    return EXCEPTION_REFERENCE_IN_USE;
                }

                if (((error?.["odata.error"]?.innererror?.internalexception?.internalexception?.message) ?? "").includes("conflicted with the check constraint"))
                {
                    return EXCEPTION_REFERENCE_INVALID;
                }

                let errorThrown = _getExceptionMessageAPI(error);

                if (errorThrown)
                {
                    if (errorThrown.toLowerCase().includes("this record is currently in use")
                        || errorThrown.toLowerCase().includes("conflicted with the reference constraint"))
                    {
                        return EXCEPTION_REFERENCE_IN_USE;
                    }

                    if (errorThrown.toLowerCase().includes("conflicted with the check constraint"))
                    {
                        return EXCEPTION_REFERENCE_INVALID;
                    }

                    if (errorThrown.toLowerCase().includes("could not find matching token"))
                    {
                        return EXCEPTION_EXPIRED_SESSION;
                    }

                    //custom error message
                    if (errorThrown.includes("Document has been overpaid.")
                        || errorThrown.includes("Document has been applied/voided.")
                        || errorThrown.includes("Document quantity has been over applied.")
                        || errorThrown.includes("Document has been over returned.")
                        || errorThrown.includes("Document has been overreturned.")
                        || errorThrown.includes("Duplicate From Date/To Date is not allowed.")
                        || errorThrown.includes("has been reconciled")
                        || errorThrown.includes("Annual Tax Error"))
                    {
                        return errorThrown;
                    }
                    else if (errorThrown.includes("The INSERT statement conflicted with the FOREIGN KEY constraint \"FK_QC_UserInGroups_rel_QC_UserGroup_UserGroupId\""))
                    {
                        return "The User Group is not available. Please select a different User Group.";
                    }
                    else if (errorThrown.includes("ApprovalSubmission|IApprovalService"))
                    {
                        return EXCEPTION_UNEXPECTED + " Instance id = '" + (error?.ExceptionMessage ?? "").substring((error?.ExceptionMessage ?? "").lastIndexOf("'"), 85) + "'";
                    }
                    else if (errorThrown.includes("MthEmyp over MD"))
                    {
                        return (error?.ExceptionMessage ?? "").substr(((error?.ExceptionMessage ?? "").indexOf('-') + 1), (error?.ExceptionMessage ?? "").length);
                    }

                    const errCode = ((error?.ExceptionMessage) ?? "").trim() != "" ? error.ExceptionMessage.trim() : EXCEPTION_UNEXPECTED;
                    const errDesc = errorThrown.replace(/\"|\'/g, "&quot;");
                    return (errDesc.trim() != "" && errCode.replaceAll(".", "").replaceAll(" ", "") != errDesc.replaceAll(".", "").replaceAll(" ", ""))
                        ? `${errCode} <a ng-click="$parent.msgHeader='${errDesc}'; msgHeader='${errDesc}'; $event.stopPropagation();" target="_blank" style="cursor:pointer">Show Details</a>`
                        : errCode;
                }
                else
                {
                    //As observed, this is thrown by odata controller with HTTP request
                    return ((typeof (error?.["odata.error"]?.innererror?.message) === "string") && (error?.["odata.error"]?.innererror?.message) != "") ? error["odata.error"].innererror.message : EXCEPTION_UNEXPECTED;
                }
            }

            return EXCEPTION_UNEXPECTED;
        }
        catch { }

        return EXCEPTION_UNEXPECTED;
    }

    return {
        gridException: (error) =>
        {
            _unAuth();

            if ((error?.status) === "error")
            {
                return _getStatus(error);
            }
            else if (typeof (error?.status) === "object" && ((error?.errorThrown?.statusText) === "error" || (error?.errorThrown?.statusText) === "Internal Server Error"))
            {
                let _error = _.cloneDeep(error)

                //i'm lazy to find out why
                _error.xhr.status = _error.errorThrown.status;
                _error.xhr.responseText = _error.errorThrown.responseText;
                _error.xhr.responseJSON = _error.errorThrown.responseJSON;

                return _getStatus(_error);
            }
            else
            {
                return _getStatus();
            }
        },
        apiException: (error, status) =>
        {
            _unAuth();

            if (typeof (error?.status) != "undefined")
            {
                return _getStatusAPI(error.status, error.data);
            }
            else
            {
                return _getStatusAPI(status, error);
            }
        }
    };
}]);